/**
 * Modality (0008,0060) codes offered wherever a user filters, matches or picks by modality: the
 * studies list, the Link send-a-case list, the teleconsultation worklist, routing rules and
 * radiologist affinity, the group report-defaults matrix, and every schedule picker and filter.
 *
 * One list, so a study that can arrive with a code can be found by it on every surface. Before it
 * existed each surface typed out its own: intraoral dental (IO) and fluoroscopy (RF) studies landed
 * in the studies list with no filter that could find them, and the schedule could set up a room of
 * a type that its own filter did not recognise.
 *
 * The codes are what a device writes, not what a person calls the exam: dental films are IO, a
 * fluoroscope is RF. Retired DICOM codes such as FS (fundoscopy) stay out. Every consumer compares
 * codes verbatim (the backend with `= ANY(...)`), so listing a code here is all it takes to make it
 * filterable.
 *
 * Ordered by how often a veterinary practice reads each: the everyday five, then dental,
 * fluoroscopy and angiography, nuclear medicine, the rarer rest, and OT (other) last.
 */
export const MODALITY_CODES = [
    'DX',
    'CR',
    'CT',
    'MR',
    'US',
    'IO',
    'PX',
    'RF',
    'XA',
    'NM',
    'PT',
    'MG',
    'ES',
    'XC',
    'OT',
];
/** Whether a value is one of the shared modality codes (exact, case-sensitive: codes are uppercase). */
export function isModalityCode(value) {
    return MODALITY_CODES.includes(value);
}
